import { render, staticRenderFns } from "./Commercial.vue?vue&type=template&id=a288088c&scoped=true&"
import script from "./Commercial.vue?vue&type=script&lang=js&"
export * from "./Commercial.vue?vue&type=script&lang=js&"
import style0 from "./Commercial.vue?vue&type=style&index=0&id=a288088c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a288088c",
  null
  
)

export default component.exports